import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/about-banner.jpg';
import aboutprofile from '../assests/img/about-por-ajis.jpg';


function Aboutpageasjs() {
return (
    <div >
    
    <Header/>
    {/* <Showlist/> */}
    <div className='container'>
        <div className='about-banner'>
            <img src={aboutBanner} alt=""/>
        </div>
    </div>
    
    <div className='container main-contant'>
      <div className='inner-page-container'>
        <h1 className='page-title'>About Agra Silver Jewellery Show</h1>

        <img src={aboutprofile} className='about-profile' alt=""/>
        <p>
        All India Gem And Jewellery Domestic Council is a national trade federation established with the objective to address the industry, its functioning and its cause with a 360° approach to promote and progress its growth, while protecting the industry's interests. As a self-regulated trade body, GJC, since the last 19 years, has been serving as a bridge between the Government and the trade as well as undertaking various initiatives on behalf of and for the industry.</p>

<p>GJC represents the interests of over 6 lakh gem and jewellery businesses from across the country. GJC represents various industry segments such as Manufacturers, Retailers, Wholesalers, Allied, gold, silver, platinum, diamonds, Gem stones, machinery, etc. including the entire industry value chain from bullion to retail.</p>

<p>GJC also undertakes various initiatives and programmes that are aimed at improving industry business practices, promote compliance, standardization and transparency, promoting professionalism for the growth and development of the industry sector. The organization also initiates various promotional activities to further retail businesses as well as manufacturing segments through various dedicated platforms designed for the purpose.</p>

<p>With the view to develop skills, promote entrepreneurship and expand career opportunities, GJC undertakes various educational programmes for skills upgrade of artisans, retail segment, etc., offers sponsorship to deserving design students and works closely with various gem and jewellery institutes to encourage talent and facilitates opening up of opportunities for an emerging workforce.
        </p>
      </div>
    
    </div>
    <Footer/>
     </div>
    )
}

export default  Aboutpageasjs;
